import { useOtherSettings } from '@namespace/cms';
import { CMSPaymentServicesDescription } from '../../types/paymentService';

export const usePSDescriptions = (): CMSPaymentServicesDescription => {
  const { paymentServicesDescription = {} } = useOtherSettings();
  return paymentServicesDescription;
};
